(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDetailController', DinghyEventDetailController);

    DinghyEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DinghyEvent', 'Profile', 'Dinghy'];

    function DinghyEventDetailController($scope, $rootScope, $stateParams, previousState, entity, DinghyEvent, Profile, Dinghy) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:dinghyEventUpdate', function(event, result) {
            vm.dinghyEvent = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
